var es = require('elasticsearch');

var client = new es.Client({
    host: 'https://search-eot-pub-kckftkvfhiytst7hsmwwvzqxv4.ap-northeast-2.es.amazonaws.com',

});

function search (myIndex, myType, body = {}){
    /*client.search({
        index: myIndex,
        type: myType,
        body: {
            // size: 0,
            aggs: {
                duplicateCount: {
                    terms: {
                        field: 'i_idx',
                        min_doc_count: 2,
                        size: 0,
                    },
                    aggs: {
                        duplicateDocuments: {
                            top_hits: {},
                        }
                    }
                }
            }//
        }
    })*/
    return client.search({
        index: myIndex,
        type: myType,
        body: body
    }).then(function (resp) {
        return resp;
    }, function (err) {
        console.trace(err.message);
        return [];
    });
}

function elasticDelete(myIndex, myType, id) {
    return client.delete({
        index: myIndex,
        type: myType,
        id: id,
    }).then(function (resp) {
        return resp;
    }, function (err) {
        console.trace(err.message)
        return err;
    })
}

export { search, elasticDelete }
